"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = void 0;
/**
 * It checks if value is empty
 *
 * @category Function
 * @param {any} - value to be checked
 * @returns {Boolean} returns boolean if value is empty
 *
 * @example
 * isEmpty('') //=> true
 * isEmpty({}) //=> true
 * isEmpty([]) //=> true
 * isEmpty() //=> true
 */
var isEmpty = function (value) {
    return (value === null ||
        value === '' ||
        typeof value === 'undefined' ||
        (typeof value === 'object' && Object.keys(value).length === 0));
};
exports.isEmpty = isEmpty;
